import React from 'react'
import styled from 'styled-components'
import { Menu as MenuG } from 'grommet'
// import { isMobile } from 'react-device-detect'

import TipDrop from './TipDrop'

const Menu = styled(MenuG)`
  padding: 9px;
  @media (max-width: 900px) {
    padding: ${props => props.mobilePad};
  }
  /* & > div {
    padding: 9px;
    @media (max-width: 900px) {
      padding: 7px;
    }
  } */
`

const MoreButton = ({
  menuItems,
  position = 'top',
  icon,
  content,
  children,
  mobilePad = '7px',
}) => {
  // const [over, setOver] = React.useState(false)
  // const ref = React.useRef()

  return (
    <TipDrop content={content} position={position}>
      <Menu
        // onMouseEnter={isMobile ? undefined : () => setOver(true)}
        // onMouseLeave={isMobile ? undefined : () => setOver(false)}
        // onBlur={isMobile ? undefined : () => setOver(false)}
        // onFocus={() => setOver(false)}
        dropAlign={{ top: 'bottom', right: 'right' }}
        dropProps={{ stretch: false }}
        icon={icon}
        items={menuItems}
        dropBackground="baseBackground"
        mobilePad={mobilePad}
      >
        {children}
      </Menu>
    </TipDrop>
  )
}

export default MoreButton
